<script>
  import Moon from "svelte-loading-spinners/dist/ts/Moon.svelte";
  import classNames from "../utils/classNames";

  export let loading = true;
  export let duration = "1s";
  export let size = 4;
  export let height = "h-4";
</script>

{#if loading}
  <div
    id="loader"
    class={classNames(
      "min-w-full absolute top-0 z-10 h-[100%] loader-containers text-center",
      $$props.class
    )}
  >
    <div class={classNames("align-middle inline-block", height)}>
      <Moon {size} color="#FF3E00" unit="rem" {duration} />
    </div>
    <div class="align-middle inline-block h-full" />
  </div>
{/if}
